import './AppSettingsModal.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppSettingName, ManifestApplicationSettings } from '@manifest-cyber/types/interface/appSettings';
import { AppSettingNames } from '@manifest-cyber/types/dist/appSettings';
import { useToggleAppSetting } from '../../hooks/mutations/useToggleAppSetting';
import { SettingToggle } from '../SettingToggle/SettingToggle';
import ManifestModal from '../ManifestModal/ManifestModal';

interface Props {
  open: boolean;
  onClose: () => void;
  appSettings: ManifestApplicationSettings | null;
}

export const AppSettingsModal = ({ open, onClose, appSettings }: Props) => {
  const { t } = useTranslation();

  const [errors, setErrors] = useState<string[]>([]);
  const { mutateAsync: toggleAppSetting } = useToggleAppSetting();

  const cleanupClosedModal = () => {
    setErrors([]);
  };

  const handleCancel = () => {
    cleanupClosedModal();
    onClose();
  };

  const handleToggle = async (key: string, checked: boolean): Promise<boolean> => {
    try {
      const { data: res } = await toggleAppSetting({ name: key as AppSettingName, value: checked  });
      if (res?.errors?.length > 0) {
        setErrors(res.errors);
        return !checked;
      }
    } catch (error) {
      setErrors([(error as Error).message as string]);
      return !checked;
    }
    return checked;
  };

  return (
    <ManifestModal
      title={t('page.administration.app-settings-modal.title')}
      opened={open}
      onClose={handleCancel}
      size={'md'}
    >
      <div className="settings-list">
        <SettingToggle
          id="oss_scan"
          title={t(`page.administration.app-settings-modal.${AppSettingNames.oss_scan}.name`)}
          description={t(`page.administration.app-settings-modal.${AppSettingNames.oss_scan}.description`)}
          checked={appSettings?.oss_scan || false}
          onChange={handleToggle}
        />
        <SettingToggle
          id="background_processing"
          title={t(`page.administration.app-settings-modal.${AppSettingNames.background_processing}.name`)}
          description={t(`page.administration.app-settings-modal.${AppSettingNames.background_processing}.description`)}
          checked={appSettings?.background_processing || false}
          onChange={handleToggle}
        />
      </div>
    </ManifestModal>
  );
};

export default AppSettingsModal;
